<template>
    <div class="sampleForm">
        <el-container>
            <el-main>
                <div class="form">
                    <div class="title">
                        <h1>견적</h1>
                    </div>
                    <br>
                    <el-form ref="form" inline :model="form" label-width="120px">
                        <el-form-item style="font-weight:bold">
                            업체 :
                        </el-form-item>
                        <el-form-item>
                            <ACustomerSelector @name="customerName" />
                        </el-form-item>
                        <br>
                        <div class="totalPrice">
                            견적금액 ￦ {{ totalPrice }} ( {{totalPrice | numberToKorean}} )
                        </div>
                        <table>
                            <tr>
                                <th style="width:60px;">순번</th><th class="standard">품목명</th><th class="amount">수량</th><th class="standard">단가</th><th class="standard">공급가</th><th class="standard">세액</th><th class="standard">비고</th>
                            </tr>
                            <tr v-for="(n,index) in 10" :key="index">
                                <td>{{index+1}}</td>
                                <td>
                                    <div :class="'productName'+index">
                                        <AProductSelector @name="productName" :id="index"></AProductSelector>
                                    </div>
                                </td>
                                <td>
                                    <div class="amount">
                                        <el-input v-model="list[index].amount" :id="'amount'+index" @input="calculation(index),total(10,'totalPrice','totalSupplyPrice','totalTax')"></el-input>
                                    </div>
                                </td>
                                <td>
                                    <div class="standard">
                                        <el-input v-model="list[index].unitPrice" :id="'unitPrice'+index" v-comma @input="calculation(index),total(10,'totalPrice','totalSupplyPrice','totalTax')"></el-input>
                                    </div>
                                </td>
                                <td>
                                    <el-input v-model="list[index].supplyPrice" readonly :id="'supplyPrice'+index" v-comma></el-input>
                                </td>
                                <td>
                                    <el-input v-model="list[index].tax" readonly :id="'tax'+index" v-comma></el-input>
                                </td>
                                <td>
                                    <div class="standard">
                                        <el-input v-model="list[index].comment"></el-input>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td colspan="4" style="text-align:center;">
                                    합계: 
                                </td>
                                <td>
                                    <el-input v-comma v-model="totalSupplyPrice" id="totalSupplyPrice" readonly></el-input>
                                </td>
                                <td>
                                    <el-input v-comma v-model="totalTax" id="totalTax" readonly></el-input>
                                </td>
                                <td>
                
                                </td>
                            </tr>
                        </table>
                    </el-form>
                    <br>
                    <div class="submit">
                        <input type="hidden" v-comma v-model="totalPrice" id="totalPrice" readonly>
                        <el-button type="primary" @click="addEstimation()">등록</el-button>
                    </div>
                </div>
            </el-main>
        </el-container>
    </div>
</template>

<script>
import * as calc from '../common/function/calculation'
import axios from 'axios';

var data = function(seq,name="",amount="",unitPrice="",supplyPrice="",tax="",comment=""){
    this.seq = seq;
    this.name = name;
    this.amount = amount;
    this.unitPrice = unitPrice;
    this.supplyPrice = supplyPrice;
    this.tax = tax;
    this.comment = comment;
}
export default {  
    name: 'sampleForm',
    data() {
        return {
            list:[],
            totalPrice:0,
            totalSupplyPrice:0,
            totalTax:0,
            form:{
                customerName:'',
                list:[],
                totalPrice:0
            }
        };
    },
    created(){
        this.init()
    },
    methods:{
        addEstimation(){
            for(var i=0; i<10; i++){
                this.list[i].seq=i
                const list = this.list[i]
                if(list.name || list.amount || list.unitPrice){
                    this.form.list.push(new data(list.seq.toString(),list.name,list.amount,list.unitPrice.replace(/,/g,""),
                    list.supplyPrice.replace(/,/g,""),list.tax.replace(/,/g,""),list.comment))
                }
            }
            this.form.totalPrice=parseInt(this.totalPrice.replace(/,/g,""))
            this.submit(this.form)
        },
        submit(form) {
            const path = 'http://localhost:5000/estimate';
            axios.post(path, form)
                .then(() => {
                    console.error("success")
                })
                .catch((error) => {
                    console.error(error)
            });
        },
        calculation(index){
            return calc.default.calculation(index,'amount','unitPrice','supplyPrice','tax'); 
        },
        total(index,totalPriceId,totalSupplyPriceID,totalTaxID){
            return calc.default.total(index,totalPriceId,totalSupplyPriceID,totalTaxID);
        },
        init() {
            for (let i=0; i<10; i++) {
                this.list.push(new data);
            }
        },
        customerName(name){
            this.form.customerName=name
        },
        productName(name,index){
            this.list[index].name=name
        }
    }
};
</script>

<style>
.product, table, tr, th, td, .totalPrice{
    border: 1px solid black;
    border-collapse: collapse;
}
.totalPrice, .caution, .submit, .title, .customer{
    padding-top: 10px;
    padding-bottom: 10px;
}
.customer, .product, .totalPrice{
    margin-bottom: 0px;
}
.form{
    width:1100px;
}
table{
    width:900px;
    text-align: center;
}
td{
    height: 30px;
}
.title{
    text-align: left;
    border-bottom: 1px silver solid;
}
.customer{
    text-align: left;
    
}
.totalPrice{
    font-weight: bold;
    width:900px;
}
.sampleCustomer{
    display:inline;
}
.submit{
    border-top: 1px silver solid;
    text-align: left;
    margin-right: 50px;
}
.amount input.el-input__inner, .amount{
    width:70px;
}
.standard input.el-input__inner,.standard{
    width:150px;
}
input.el-input__inner{
    height: 30px;
}
</style>